import type { ReactNode } from 'react';
import styles from './ui.module.css';

/** Занять всю полосу: подтверждение архивирования встаёт вместо пары кнопок. */
export function Grow({ children }: { children: ReactNode }) {
  return <div className={styles.grow}>{children}</div>;
}
